import { EProcessState } from '@/models/enums';
import { useState, useCallback } from 'react';

export interface IUseProcessStateParams {
  initialState?: EProcessState;
};

export function useProcessState(params: IUseProcessStateParams = {}) {
  const { initialState = EProcessState.Idle } = params;
  const [state, setState] = useState<EProcessState>(initialState);

  const start = useCallback(() => setState(EProcessState.Loading), []);
  const complete = useCallback(() => setState(EProcessState.Completed), []);
  const fail = useCallback(() => setState(EProcessState.Error), []);
  const reset = useCallback(() => setState(EProcessState.Idle), []);

  const isIdle = state === EProcessState.Idle;
  const isLoading = state === EProcessState.Loading;
  const isCompleted = state === EProcessState.Completed;
  const isError = state === EProcessState.Error;

  return {
    state,
    setState,
    start,
    complete,
    fail,
    reset,
    isIdle,
    isLoading,
    isCompleted,
    isError,
  };
}